import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SituatieCurentaComponent } from './situatie-curenta.component';
import { AddSituatieCurentaComponent } from './add-situatie-curenta/add-situatie-curenta.component';
import { EditSituatieCurentaComponent } from './edit-situatie-curenta/edit-situatie-curenta.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
    declarations: [
        SituatieCurentaComponent,
        AddSituatieCurentaComponent,
        EditSituatieCurentaComponent
    ],
    imports: [
        CommonModule, MaterialModule, FormsModule, ReactiveFormsModule
    ],
    exports: [SituatieCurentaComponent],
})
export class SituatieCurentaModule { }
